import { render, staticRenderFns } from "./SuccessDeliveredPerform.vue?vue&type=template&id=504d9b7d&scoped=true"
import script from "./SuccessDeliveredPerform.vue?vue&type=script&lang=js"
export * from "./SuccessDeliveredPerform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504d9b7d",
  null
  
)

export default component.exports